<template>
  <a-radio-group v-if="tagType == 'radio'" @change="handleInput" :value="getValueSting" :disabled="disabled">
    <a-radio v-for="(item, key) in enumOptions" :key="key" :value="item.code">{{ item.value }}</a-radio>
  </a-radio-group>

  <a-radio-group
    v-else-if="tagType == 'radioButton'"
    buttonStyle="solid"
    @change="handleInput"
    :value="getValueSting"
    :disabled="disabled"
  >
    <a-radio-button v-for="(item, key) in enumOptions" :key="key" :value="item.code">{{ item.value }}</a-radio-button>
  </a-radio-group>
  <a-select
    v-else-if="tagType == 'select'"
    :getPopupContainer="(target) => target.parentNode"
    placeholder="123456"
    :disabled="disabled"
    :value="getValueSting"
    @change="handleInput"
  >
    <a-select-option :value="undefined">请选择</a-select-option>
    <a-select-option v-for="(item, key) in enumOptions" :key="key" :value="item.code">
      <span style="display: inline-block; width: 100%" :title="item.value">
        {{ item.value }}
      </span>
    </a-select-option>
  </a-select>
</template>

<script>
import { ajaxGetEnumItems } from '@/api/api'

export default {
  name: 'JEnumSelectTag',
  props: {
    enumCode: String,
    placeholder: String,
    triggerChange: Boolean,
    disabled: Boolean,
    value: [String, Number],
    type: String
  },
  data() {
    return {
      enumOptions: [],
      tagType: ''
    }
  },
  watch: {
    enumCode: {
      immediate: true,
      handler() {
        this.initDictData()
      }
    },
    placeholder: {
      immediate: true,
      handler(val) {
        return val
      }
    }
  },
  created() {
    if (!this.type || this.type === 'list') {
      this.tagType = 'select'
    } else {
      this.tagType = this.type
    }
    //获取字典数据
    // this.initDictData();
  },
  computed: {
    getValueSting() {
      return this.value != null ? this.value.toString() : null
    }
  },
  methods: {
    initDictData() {
      //优先从缓存中读取字典配置
      // if(getDictItemsFromCache(this.dictCode)){
      //   this.enumOptions = getDictItemsFromCache(this.dictCode);
      //   return
      // }

      //根据字典Code, 初始化字典数组
      ajaxGetEnumItems(this.enumCode, null).then((res) => {
        if (res.success) {
          this.enumOptions = res.result
        }
      })
    },
    handleInput(e) {
      let val
      if (this.tagType == 'radio') {
        val = e.target.value
      } else {
        val = e
      }
      if (this.triggerChange) {
        this.$emit('change', val)
      } else {
        this.$emit('input', val)
      }
    },
    setCurrentDictOptions(enumOptions) {
      this.enumOptions = enumOptions
    },
    getCurrentDictOptions() {
      return this.enumOptions
    }
  }
}
</script>

<style scoped></style>
